<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="content p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <p class="mb-12">{{ 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.MANAGE_USER_CERTIFICATES.DESCRIPTION' | translate }}</p>
    <mat-list class="mat-elevation-z2">
        <mat-list-item *ngFor="let moduleCertificate of moduleCertificates">
            <div class="w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
                <mat-checkbox (change)="checkboxChangedValue()" [(ngModel)]="moduleCertificate.isSelected" [checked]="moduleCertificate.isSelected">
                    <div class="ml-12" fxLayout="column">
                        <h3 class="file-name">{{ moduleCertificate.certificate.certificateName }}</h3>
                        <div class="file-info-container" fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon>description</mat-icon>
                            <span>{{ moduleCertificate.certificate.filename }}</span>
                        </div>
                    </div>
                </mat-checkbox>
            </div>
        </mat-list-item>
        <mat-divider></mat-divider>
    </mat-list>
    <mat-checkbox class="mt-32" [(ngModel)]="sendNotifications">{{ 'GENERAL.BUTTON.SEND_NOTIFICATIONS' | translate }} </mat-checkbox>
    <a class="mt-12 pointer" (click)="goToManageUserCertificates()">{{ 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.LABEL.MANAGE_CERTIFICATES' | translate }}</a>
    <div class="divider mt-32"></div>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="actionButtonText" (onClick)="saveChanges()" [disabled]="isSaveButtonDisabled"></app-flat-button>
</div>
